<template>
  <div class="space-y-3" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
    <!-- Progress Bar -->
    <div class="flex items-center space-x-3">
      <div class="flex-1 bg-blue-200 rounded-full h-2 overflow-hidden">
        <div
          class="bg-blue-600 h-full rounded-full transition-all duration-300"
          :style="{ width: `${progress}%` }" />
      </div>
      <span class="text-sm font-medium text-blue-700 w-12 text-right">
        {{ progress }}%
      </span>
    </div>

    <!-- Current Status -->
    <div class="flex items-center justify-between text-xs">
      <div class="flex items-center space-x-2">
        <svg class="w-4 h-4 text-blue-600 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
        <span class="text-blue-700">
          <span v-if="currentCategory">
            Syncing {{ formatCategory(currentCategory) }}...
          </span>
          <span v-else>
            Receiving data...
          </span>
        </span>
      </div>
      <span v-if="samplesReceived > 0" class="text-blue-600">
        {{ formatNumber(samplesReceived) }} samples
      </span>
    </div>

    <!-- Completed Categories -->
    <div v-if="completedCategories.length > 0" class="flex flex-wrap gap-1.5">
      <span
        v-for="category in completedCategories"
        :key="category"
        class="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-green-100 text-green-800">
        <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
        {{ formatCategory(category) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SyncProgressIndicator',

  props: {
    progress: {
      type: Number,
      default: 0
    },
    currentCategory: {
      type: String,
      default: null
    },
    samplesReceived: {
      type: Number,
      default: 0
    },
    completedCategories: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    formatCategory(category) {
      if (!category) return ''
      // Convert snake_case or camelCase to Title Case
      return category
        .replace(/_/g, ' ')
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim()
    },

    formatNumber(num) {
      if (num === null || num === undefined) return '0'
      return num.toLocaleString()
    }
  }
}
</script>
